import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function AnimatedHeadline({
  text,
  className,
  style,
  tag: Tag = "h2",
  "data-testid": testId,
}) {
  const ref = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const words = ref.current.querySelectorAll(".ahl-word");
      gsap.fromTo(
        words,
        { y: "115%", rotationX: -75, filter: "blur(6px)", opacity: 0 },
        {
          y: "0%", rotationX: 0, filter: "blur(0px)", opacity: 1,
          stagger: 0.055, duration: 0.8, ease: "power3.out",
          scrollTrigger: { trigger: ref.current, start: "top 87%" },
        }
      );
    }, ref);
    return () => ctx.revert();
  }, []);

  return (
    <Tag ref={ref} className={className} style={style} data-testid={testId}>
      {text.split(" ").map((word, i, arr) => (
        <span
          key={i}
          style={{ display: "inline-block", overflow: "hidden", verticalAlign: "bottom", paddingBottom: "0.04em" }}>
          <span className="ahl-word" style={{ display: "inline-block" }}>
            {word}
          </span>
          {i < arr.length - 1 && "\u00a0"}
        </span>
      ))}
    </Tag>
  );
}
